<template lang="pug">
	.standard-kpi-display
		.title-top
			span {{'Standard KPI'}}
		.metrics-list(:campaigns="campaigns?.length")
			.metric-badge(v-for="metric in metricsMetadata" :style="{'background': metric.background}")
				.metric-count {{metricsCounts[metric.codename]}}
				.metric-title {{metric.title}}
</template>

<script>
import Screen 			from './../../mixins/screen';
export default {
	name: 'StandardKPIDisplay',
	components: {
	},
	mixins: [Screen],
	screen: {
		updateOn: [],
		events: {

		}
	},
	props: ["metricsMetadata", "campaigns"],
	watch: {
		campaigns() {
			this.collectData();
		}
	},
	data() {
		return {
			metricsCounts: {},
			showed: true
		}
	},
	methods: {
		collectData(action, ...params) {
			Object.values(this.metricsMetadata).forEach(metricMetadata => {
				this.metricsCounts[metricMetadata.codename] = this.campaigns.reduce((acc, cur) => parseInt(cur.metrics[metricMetadata.codename] || 0) + acc, 0);
			});
		},

	}
}

</script>

<style lang="sass">
	.standard-kpi-display
		height: 150px
		min-height: 150px
		background-color: #24252f
		width: 100%
		display: flex
		flex-direction: column
		border-radius: 15px

		>.title-top
			border-bottom: 2px solid #3d3d3d
			height: 48px
			padding-left: 15px
			font-size: 20px
			display: flex
			align-items: center

		>.metrics-list
			display: flex
			flex-direction: row
			gap: 20px
			padding: 20px 0 20px 20px

			>.metric-badge
				width: 175px
				height: 75px
				border-radius: 10px

				>.metric-count
					font-size: 20px
					font-weight: bold
					padding-left: 7px
					padding-top: 3px

				>.metric-title
					padding-left: 7px
					padding-top: 10px
					color: black

</style>
